<template>
  <el-dialog
    :appendToBody="true"
    :title="uploadTitle"
    :visible.sync="uploadVideoVisible"
    @close="closeUploadDialog"
    width="470px"
    custom-class="qm-upload-video-dialog"
  >
    <div v-if="uploadType == 'aliyun'">
      <template v-if="finalStatus == 0">
        <div>
          <el-upload
            class="qm-upload__upload-demo"
            drag
            :auto-upload="false"
            action=""
            :show-file-list="false"
            :on-change="uploadChange"
          >
            <svg class="qm-import__upload-icon" viewBox="0 0 1024 1024" width="200" height="200">
              <path
                d="M909 897H115a50 50 0 0 1-50-50V177a50 50 0 0 1 50-50h370a50 50 0 0 1 50 50v62a10 10 0 0 0 10 10h241a50 50 0 0 1 50 50v58h73a50 50 0 0 1 50 50v440a50 50 0 0 1-50 50zM505 309a30 30 0 0 1-30-30v-72a20 20 0 0 0-20-20H145a20 20 0 0 0-20 20v610c0 11.046 9.377 20 20.422 20H209a20 20 0 0 0 20-20V407a50 50 0 0 1 50-50h497v-28a20 20 0 0 0-20-20H535m364 128a20 20 0 0 0-20-20H309a20 20 0 0 0-20 20v400h590a20 20 0 0 0 20-20V437zM650.659 615.8l-26.618-26.53V737a30 30 0 0 1-30 30h-0.113a30 30 0 0 1-30-30V589.275L537.309 615.8a30.006 30.006 0 0 1-42.509-42.36l77.928-77.669a30.127 30.127 0 0 1 42.506 0l77.929 77.669a30.007 30.007 0 0 1-42.504 42.36z"
              />
            </svg>
            <div class="el-upload__text">支持文件拖拽至框内上传</div>
            <el-button size="small">选择文件</el-button>
            <div class="el-upload__tip">支持mp4或mp3格式，大小不超过50M</div>
          </el-upload>
        </div>
      </template>
      <template v-if="finalStatus === 1 || finalStatus === 2 || finalStatus === 4">
        <div>
          <span>{{ videoName }}</span>
          <el-progress :percentage="authProgress" v-if="finalStatus === 1"></el-progress>
          <el-progress :percentage="authProgress" v-if="finalStatus === 2" status="success"></el-progress>
          <el-progress :percentage="authProgress" v-if="finalStatus === 4" status="exception"></el-progress>
          <span>{{ statusText }}</span>
        </div>
      </template>
      <template v-if="finalStatus === 3">
        <div class="qm-upload__img">
          <img
            :src="
              videoForm.coverUrl || 'https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png'
            "
            alt=""
          />
          <!-- <img src="https://vods.qmai.cn/35b078bbc79f443b8b6cc42cedc2eace/snapshots/410b6f7d45f3428c841319bf42a627e5-00005.jpg" alt=""> -->
          <div class="qm-upload__del-btn" @click="delVideo"><i class="el-icon-delete"></i></div>
        </div>
      </template>
    </div>
    <div v-else>
      <el-form :model="videoForm" status-icon ref="videoForm" label-width="120px">
        <el-form-item label="音视频路径：" required>
          <el-input v-model="videoForm.netUrl" autocomplete="off"></el-input>
          <span class="qm-upload__url-note">网络音视频路径请联系企迈客服获取</span>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="del-tree-footer">
      <el-button :disabled="finalStatus == 1 || finalStatus == 2" size="small" @click="closeUploadDialog"
        >取 消</el-button
      >
      <el-button :disabled="finalStatus == 1 || finalStatus == 2" size="small" type="primary" @click="addVideoSub"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { creatVideo, getAliyunAuth, getVideoCover, addVideo } from '../api'
export default {
  props: {
    currentVideoDir: {
      type: Object,
      default: () => ({}),
    },
    uploadType: {
      type: String,
      default: 'aliyun',
    },
    useScene: {
      type: String,
      default: 'library',
    },
  },
  created() {
    this.getUserId()
    this.delVideo()
  },
  computed: {
    uploadTitle() {
      const title = this.uploadType === 'aliyun' ? '本地上传' : '路径上传'
      return title
    },
  },
  data() {
    return {
      finalStatus: 0, // 上传的最终状态 0 还未上传   1 开始上传   2 上传成功并获取封面
      uploadVideoVisible: false,
      file: null,
      timeout: '',
      partSize: '',
      parallel: '',
      retryCount: '',
      retryDuration: '',
      region: '',
      userId: '',
      statusText: '',
      authProgress: 0,
      videoName: '',
      videoForm: {
        netUrl: '', // 网络地址
        coverUrl: '', // 获取的视频封面
        videoId: -1, // 阿里云视频id
        name: '', // 阿里云视频名称
        size: 0, // 阿里云视频大小
        timeId: null,
      },
      uploader: null,
    }
  },
  methods: {
    show() {
      this.uploadVideoVisible = true
    },
    // 获取阿里云视频id ----------------------
    getUserId() {
      getAliyunAuth().then(res => {
        if (res.status) {
          this.userId = res.data.aliyun.user_id
          this.region = res.data.aliyun.region
        }
      })
    },
    // 视频上传 ----------------------
    uploadChange(file) {
      // 选择视频
      this.file = file && file.raw
      const { type, size, name } = file.raw
      this.videoName = name
      if (!this.file) {
        this.$message.error('请先选择需要上传的文件!')
        return
      }
      if (this._isNotAllowedUpload(type)) {
        this.$message.error('上传文件只能是 MP4或MP3 格式!')
        return
      }
      if (size > 1048576 * 50) {
        this.$message.error('上传文件大小不能超过 50MB!')
        return
      }
      let userData = '{"Vod":{}}'
      if (this.uploader) {
        this.uploader.stopUpload()
        this.authProgress = 0
      }
      this.uploader = this.createUploader()
      this.uploader.addFile(this.file, null, null, null, userData)
      // 开始上传
      this.authUpload()
    },
    // 生成 AliyunUpload ----------------------
    createUploader() {
      const self = this
      // eslint-disable-next-line no-undef
      const uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function () {
          self.finalStatus = 1
          // '添加文件成功, 等待上传...'
          self.statusText = '等待上传'
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
          if (!uploadInfo.videoId) {
            const data = {
              title: self._isAudio(uploadInfo.file.type) ? '音频' : '视频',
              file_name: uploadInfo.file.name,
              description: '',
              cover_url: '',
              tags: '',
              file_size: uploadInfo.file.size,
            }
            creatVideo(data).then(res => {
              if (res.status) {
                // '文件开始上传...
                uploader.setUploadAuthAndAddress(
                  uploadInfo,
                  res.data.UploadAuth,
                  res.data.UploadAddress,
                  res.data.VideoId
                )
              }
            })
            self.statusText = '开始上传'
          } else {
            self.statusText = '继续上传'
            // 如果videoId有值，根据videoId刷新上传凭证
            // 取消上传会走这一步，需要请求刷新上传凭证接口 二期有取消上传再处理
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          self.statusText = '文件上传成功!'
          self.finalStatus = 2
          if (self._isAudio(uploadInfo.file.type)) {
            self.changeFinalStatus(uploadInfo.videoId)
          } else {
            window.clearInterval(self.videoForm.timeId)
            self.videoForm.timeId = setInterval(() => {
              self._getVideoCover(uploadInfo.videoId)
            }, 1000)
          }
          self.videoForm.name = uploadInfo.file.name
          self.videoForm.size = uploadInfo.file.size
        },
        // 文件上传失败
        onUploadFailed: function () {
          self.finalStatus = 4 // 上传失败
          self.statusText = '文件上传失败!'
        },
        // 取消文件上传
        onUploadCanceled: function () {
          // 文件已暂停上传
          self.statusText = '文件已暂停上传'
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          // 文件上传中
          const progressPercent = Math.ceil(progress * 100)
          self.authProgress = progressPercent
          self.statusText = '文件上传中...'
        },
        // 上传凭证超时
        onUploadTokenExpired: function () {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          // updateVideo().then(res =>{
          //     uploader.resumeUploadWithAuth(res.data.UploadAuth)
          // })
          // 视频上传限制50MB以内，暂时不会存在超时问题，以后再更新
          self.statusText = '文件超时...'
        },
        // 全部文件上传结束
        onUploadEnd: function () {
          // self.statusText = '文件上传完毕'
          self.statusText = '文件获取中...'
        },
      })
      return uploader
    },
    _isNotAllowedUpload(type) {
      return type !== 'video/mp4' && !this._isAudio(type)
    },
    // 判断文件是否是mp3音频 ----------------------
    _isAudio(type) {
      return type === 'audio/mpeg'
    },
    // 开始上传 ----------------------
    authUpload() {
      // 然后调用 startUpload 方法, 开始上传
      if (this.uploader !== null) {
        this.uploader.startUpload()
      }
    },
    // 获取视频封面 ----------------------
    _getVideoCover(id) {
      const data = {
        video_id: id,
      }
      getVideoCover(data).then(res => {
        if (res.status) {
          this.videoForm.coverUrl = res.data.Video ? res.data.Video.CoverURL : ''
          if (this.videoForm.coverUrl) {
            this.changeFinalStatus(id)
            window.clearInterval(this.videoForm.timeId)
            this.videoForm.timeId = null
          }
        }
      })
    },

    // 上传完成后修改状态 ----------------------
    changeFinalStatus(id) {
      this.videoForm.videoId = id // 阿里云视频id
      this.finalStatus = 3 // 上传并获取封面成功
    },

    // 删除选择的视频 ----------------------
    delVideo() {
      this.videoForm.coverUrl = ''
      this.videoForm.videoId = -1
      this.finalStatus = 0
    },
    // 添加视频 ----------------------
    addVideoSub() {
      if (this.uploadType === 'aliyun' && this.videoForm.videoId === -1) {
        this.$message.error('请选择要上传的音视频')
        return
      }
      if (this.uploadType === 'url' && !this.videoForm.netUrl) {
        this.$message.error('请选择要上传的音视频路径')
        return
      }
      this._addVideo()
    },
    // 添加视频封装 ----------------------
    _addVideo() {
      const data = {
        category_id: this.currentVideoDir.id,
        type: this.uploadType,
      }
      if (this.uploadType === 'aliyun') {
        data.play_id = this.videoForm.videoId
        data.cover_url = this.videoForm.coverUrl
        data.title = this.videoForm.name
        data.size = this.videoForm.size
      } else {
        data.play_url = this.videoForm.netUrl
        data.title = this.videoForm.netUrl.substring(this.videoForm.netUrl.length - 20)
      }
      if (this.useScene === 'editor') {
        this.uploadVideoVisible = false
        this.videoForm.netUrl = '' // 清空网络地址数据
        this.delVideo() // 清空阿里云视频数据
        this.$emit('videoUploadedSuccess', data)
        return
      }
      try {
        addVideo(data)
          .then(res => {
            if (res.status) {
              this.$message.success('音视频添加成功')
              this.uploadVideoVisible = false
              this.videoForm.netUrl = '' // 清空网络地址数据
              this.delVideo() // 清空阿里云视频数据
              this.$emit('videoUploadedSuccess')
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(err => {
            this.$message.error(err.message)
          })
      } catch (e) {
        this.$message.error('保存失败')
      }
    },
    // 关闭弹窗
    closeUploadDialog() {
      this.uploadVideoVisible = false
      this.videoForm.timeId && window.clearInterval(this.videoForm.timeId)
      this.finalStatus = 0
      this.$emit('closeUploadDialog')
      this.uploader = null
    },
  },
}
</script>
